import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../../features/auth";

type WeatherStationsServiceSlice = {
    date: string,
    hour?: number,
    deviceId?: string,
    timeMarks?: [string],
    timeMark?: string
}

function getInitialState() {
    const initialState: WeatherStationsServiceSlice = {
        date: new Date().toISOString(),
        hour: undefined,
        deviceId: undefined,
        timeMarks: undefined,
        timeMark: undefined
    }
    return initialState
}

export const WeatherStationsServiceSlice = createSlice({
    name: 'weatherStationsService',
    initialState: getInitialState(),
    reducers: {
        setDate(state, action: PayloadAction<any>) {
            state.date = action.payload
        },
        setHour(state, action: PayloadAction<any>) {
            state.hour = action.payload
        },
        setDeviceId(state, action: PayloadAction<any>) {
            state.deviceId = action.payload
        },
        setTimeMarks(state, action: PayloadAction<any>) {
            state.timeMarks = action.payload
        },
        setTimeMark(state, action: PayloadAction<any>) {
            state.timeMark = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setDate, setHour, setDeviceId, setTimeMarks, setTimeMark } = WeatherStationsServiceSlice.actions
export const weatherStationsServiceReducer = WeatherStationsServiceSlice.reducer;
